module.exports = __webpack_public_path__ + "img/a47f99bd68ed29143f558ba5e3f822c6.png";